import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

export type LibraryFieldValidationError =
  | 'required'
  | 'tooShort'
  | 'tooLong'
  | 'patternMismatch'
  | 'notANumber'
  | 'notAnInteger'
  | 'tooSmall'
  | 'tooLarge'
  | 'notAMultiple'
  | 'notAnOption'
  | 'incompleteObject';

export const LIBRARY_FIELD_ERROR_MESSAGES: Record<LibraryFieldValidationError, MessageDescriptor> =
  {
    required: msg`This field is required.`,
    tooShort: msg`This value is too short.`,
    tooLong: msg`This value is too long.`,
    patternMismatch: msg`This value has an unexpected format.`,
    notANumber: msg`Enter a number.`,
    notAnInteger: msg`Enter a whole number.`,
    tooSmall: msg`This value is below the allowed minimum.`,
    tooLarge: msg`This value is above the allowed maximum.`,
    notAMultiple: msg`This value does not use an allowed increment.`,
    notAnOption: msg`Choose one of the listed options.`,
    incompleteObject: msg`Fill every required value in this group, or leave the whole group empty.`,
  };

/**
 * Frontend-owned completeness rules that supplement the backend field catalog's
 * type, format, range, and option constraints.
 */
export const LIBRARY_REQUIRED_FIELDS = {
  environment: {
    businessName: true,
    businessId: false,
    environmentL1: true,
    environmentL2: true,
    latitude: true,
    longitude: true,
    addressCountry: true,
    employees: true,
  },
  operator: {
    operatorName: true,
    operatorJob: true,
    ageRange: true,
    gender: true,
    handedness: true,
  },
  device: {
    opsCode: true,
    headsetSerial: true,
  },
} as const;
